import { Http } from '@/lib/http';

export class ReportingSectorsService extends Http {
  endpoint = 'loan-pro/settings/loan-reporting-sectors';

  constructor() {
    super();
  }

  fetchSectors() {
    return this.httpClient().get(this.endpoint);
  }

  findPrimarySector(primaryId) {
    return this.httpClient().get(`${this.endpoint}/${primaryId}`);
  }

  findAllPrimarySectors() {
    return this.httpClient().get(`${this.endpoint}/primary-sectors`);
  }

  findAllSecondarySectors() {
    return this.httpClient().get(`${this.endpoint}/sub-secondary-sectors`);
  }

  findAllSubSecondarySectors() {
    return this.httpClient().get(`${this.endpoint}/sub-secondary-sectors`);
  }

  updateSector(id, updates) {
    return this.httpClient().patch(`${this.endpoint}/${id}`, updates);
  }

  createPrimarySector(sector) {
    return this.httpClient().post(this.endpoint, sector);
  }

  createSecondarySector(primarySector, secondarySector) {
    return this.httpClient().patch(
      `${this.endpoint}/${primarySector}/secondary-sector`,
      { primarySector, ...secondarySector }
    );
  }

  createSubSecondarySector(primarySector, secondarySector, subSecondarySector) {
    return this.httpClient().patch(
      `${this.endpoint}/${primarySector}/${secondarySector}/sub-secondary-sector`,
      { secondarySector, ...subSecondarySector }
    );
  }

  deletePrimarySector(id) {
    return this.httpClient().delete(`${this.endpoint}/${id}`);
  }

  deleteSecondarySector(primarySectorId, secondarySectorId) {
    return this.httpClient().patch(
      `${this.endpoint}/${primarySectorId}/secondary-sector/${secondarySectorId}`
    );
  }

  deleteSubSecondarySector(
    primarySectorId,
    secondarySectorId,
    subSecondarySectorId
  ) {
    return this.httpClient().patch(
      `${this.endpoint}/${primarySectorId}/${secondarySectorId}/sub-secondary-sector/${subSecondarySectorId}`
    );
  }
}
